import { Reveal } from "./Reveal";

const SectionHead = ({ eyebrow, title, lede, dark = false, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    <span className={`eyebrow ${dark ? "text-accent" : ""}`}>{eyebrow}</span>
    <h2
      className={`mt-5 text-3xl md:text-5xl font-semibold tracking-tight text-balance ${
        dark ? "text-white" : "text-ink"
      }`}
    >
      {title}
    </h2>
    {lede && (
      <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-white/70" : "text-slate-600"}`}>
        {lede}
      </p>
    )}
  </Reveal>
);

export default SectionHead;
